import axios from "./api";

export default {
  // ver routes
  getSeeds(page, q, getAll) {
    if (q) {
      return axios
        .get(`/api/seed/supplies?page=${page}&q=${q}`)
        .then((res) => res.data);
    } else {
      if (getAll) {
        return axios
          .get(`/api/seed/supplies?page=${page}&q=${q}`)
          .then((res) => res.data);
      } else {
        return axios
          .get(`/api/seed/supplies?page=${page}`)
          .then((res) => res.data);
      }
    }
  },
  getSeedsById(id) {
    return axios.get(`/api/seed/supply/${id}`).then((res) => res.data);
  },
  createSeed(supply) {
    return axios.post("/api/seed/supply", supply).then((res) => res.data);
  },
  removeSeed(id) {
    return axios.delete(`/api/seed/supply/${id}`).then((res) => res.data);
  },
  updateSeed(id, supply) {
    return axios.put(`/api/seed/supply/${id}`, supply).then((res) => res.data);
  },
  getNames() {
    return axios.get("/api/seeds/names").then((res) => res.data);
  },
  getSeedsByProductIdAndSeason(productId, season) {
    return axios
      .get(`/api/seed/supplies?productId=${productId}&season=${season}`)
      .then((res) => res.data);
  },
};
